import styled from 'styled-components';
import { useEffect } from 'react';
import moment from 'moment';
import { Icon, useStyledTheme } from '@equifinance/shared';
import { Link } from 'react-router-dom';
import Page from '../components/Page';
import { useBrokeragesContext } from '../contexts/brokerages';
import {
  RefreshBtn, RefreshContainer, RefreshInfo, SubHeadContainer,
} from './HomeUnderwriter';
import BrokeragesTable from '../components/BrokeragesTable';

const MyLink = styled(Link)`${({ theme }) => `
  color: ${theme.colours.link[1]};
  font-size: ${theme.fontSize[2]};
  font-weight: ${theme.fontWeight.bold};
  text-decoration: underline;
`}`;

export default function BrokerManagement() {
  const { lastRetrieved, fetchBrokerages } = useBrokeragesContext();
  const theme = useStyledTheme();

  const handleRefresh = () => {
    fetchBrokerages();
  };

  useEffect(() => {
    fetchBrokerages();
  }, []);

  return (
    <Page subHeader={(
      <SubHeadContainer>
        <Icon className="mi-document" color={theme.colours.link[1]} size={theme.fontSize[3]} />
        <MyLink to="/">Case Management</MyLink>
        <RefreshContainer>
          <RefreshInfo>
            {`Last retrieved: ${moment(lastRetrieved).format('DD/MM/YYYY, HH:mm')}`}
          </RefreshInfo>
          <RefreshBtn onClick={handleRefresh}>
            <i className="mi-refresh" />
            Refresh
          </RefreshBtn>
        </RefreshContainer>
      </SubHeadContainer>
    )}
    >
      <BrokeragesTable />
    </Page>
  );
}
